import Shipping from '../views/shipping/Index.vue';
import MonitorShipping from '../views/shipping/Monitor.vue';

import { checkauth } from '../Helper';

const ShippingCreate = () => import('../views/shipping/Create.vue');
const ShippingTracking = () => import('../views/shipping/Tracking.vue');

function auth(to, from, next) {
	checkauth().then(response => {
		if (response) {
			next();
		} else {
			next('/login');
		}
	});
}

export default [
	{
		path: '/shippings',
		name: 'shippings',
		component: Shipping,
		beforeEnter: auth,
	},
	// crea spedizione e tracking: pagine, non piu' finestre della lista
	{
		path: '/shippings/new',
		name: 'shipping-new',
		component: ShippingCreate,
		beforeEnter: auth,
	},
	{
		path: '/shippings/:id([0-9a-fA-F]{24})/tracking',
		name: 'shipping-tracking',
		component: ShippingTracking,
		beforeEnter: auth,
	},
	{
		path: '/monitor-shippings',
		name: 'monitor-shippings',
		component: MonitorShipping,
		beforeEnter: auth,
	},
];
